import React from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { ChevronDown } from "lucide-react";
import { cn } from "lib/utils";

const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef(
  (props, ref) => (
    <AccordionPrimitive.Item
      ref={ref}
      className={cn("border-b w-full", props.className)}
      {...props}
    />
  )
);
AccordionItem.displayName = "AccordionItem";

const AccordionTrigger = React.forwardRef(
  (props, ref) => (
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger
        ref={ref}
        className={cn(
          "flex flex-1 items-center justify-between transition-all py-3 [&[data-state='open']] svg:rotate-180",
          props.className
        )}
        {...props}
      >
        {props.children}
        <ChevronDown className="h-4 w-4 mr-2 shrink-0 transition-transform duration-200 mr-2" />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  )
);
AccordionTrigger.displayName = "AccordionTrigger";

const AccordionContent = React.forwardRef(
  (props, ref) => (
    <AccordionPrimitive.Content
      ref={ref}
      className="overflow-hidden text-sm transition-all data-[state='closed']:animate-accordion-up data-[state='open']:animate-accordion-down"
      {...props}
    >
      <div className={cn("pb-4 pt-0", props.className)}>{props.children}</div>
    </AccordionPrimitive.Content>
  )
);
AccordionContent.displayName = "AccordionContent";

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
